// extracted by mini-css-extract-plugin
module.exports = {"prizeInfo":"PrizeInfo_prizeInfo__3doXH","trophy":"PrizeInfo_trophy__3RepZ","text":"PrizeInfo_text__3v21g","b":"PrizeInfo_b__i_vLd"};